import { render, staticRenderFns } from "./CodeActifs.vue?vue&type=template&id=2efa1b1a&"
import script from "./CodeActifs.vue?vue&type=script&lang=js&"
export * from "./CodeActifs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports